const VARIABLE_MARKER = /\$([A-Za-z]+)(?![A-Za-z])/g;

/** Mirrors the resolver: `$FieldName` stands for the property the expression belongs to. */
export function lookupLabel(key: string, tokenName: string): string {
  return key.replace(/\$FieldName(?![A-Za-z])/gi, tokenName).replace(VARIABLE_MARKER, '<$1>');
}
